import React from 'react'
import Analytics from './components/Analytics'
import Hero from './components/Hero'
import Navbar from './components/Navbar'
import Projects from './components/Projects'
import PData from './PData';
import { BrowserRouter,Router,Route } from 'react-router-dom'
import Progress from './components/Progress'
import Footer from './components/Footer';


const App = () => {
  return (
    <>



    <Navbar/>
    <Hero/>
    <Analytics/>
    <div className='md:flex lg:flex-shrink bg-[white] justify-evenly pt-[100px] flex-wrap '>
      
   
    <Projects
    title={PData[0].title}
    link={PData[0].link}
    para={PData[0].para}
    img={PData[0].img}
    />
    <Projects
    title={PData[1].title}
    link={PData[1].link}
    para={PData[1].para}
    img={PData[1].img}
    />
    <Projects
     title={PData[2].title}
     link={PData[2].link}
     para={PData[2].para}
     img={PData[2].img}/>
 <Footer/>
    </div>
  
    </>
  )
}

export default App